import { Component } from 'react';

import PropTypes from 'prop-types';

import { logger } from '../logger';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidMount() {
    const { componentTitle } = this.props;
    if (componentTitle) {
      logger.info(`${componentTitle} Screen loaded successfully.`);
    }
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(e) {
    const { componentTitle, errorCallback } = this.props;
    logger.error(`ERROR encountered on ${componentTitle} Screen`, e);
    errorCallback();
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;
    if (hasError) {
      // You can render any custom fallback UI
      return <></>; // Using a fragment to return a consistent type
    }
    return children;
  }
}

export default ErrorBoundary;

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  errorCallback: PropTypes.func,
  componentTitle: PropTypes.string
};

ErrorBoundary.defaultProps = {
  errorCallback: () => {},
  componentTitle: ''
};
